const normalizeProfilePayload = (payload) => {
    const normalized = {
        accountStatus: payload.accountStatus,
        countryId: payload.countryId,
        email: payload.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        secondName: payload.secondName,
        phoneNumber: payload.phoneNumber,
        profileImageId: payload.profileImageId,
        roleIds: payload.roleIds,
    };
    if (payload.password)
        normalized.password = payload.password;
    return normalized;
};
export default (repositoryInstance) => {
    function get() {
        return repositoryInstance.get(`/users/my-profile`);
    }
    function edit(payload) {
        return repositoryInstance.patch(`/users/my-profile`, normalizeProfilePayload(payload));
    }
    function deletePicture() {
        return repositoryInstance.delete(`/users/my-profile/profile-image`);
    }
    function changePassword(request) {
        return repositoryInstance.post(`/users/my-profile/password`, {
            newPassword: request.newPassword,
            password: request.password,
        });
    }
    return Object.freeze({
        get,
        edit,
        deletePicture,
        changePassword,
    });
};
//# sourceMappingURL=profile.js.map